/* ml-menu.js — Main Menu v2 mobile drawer injection.
   Desktop panels are injected by the theme's own MeganavManager.
   This script only handles the mobile drawer: for each hidden
   [data-ml-mobile] source rendered by the ml-menu-* sections, it
   finds the matching drawer item (data-mobile-dropdown-rel) and
   turns it into an accordion with the panel's tile grid inside. */
(function () {
  'use strict';

  function init() {
    var sources = document.querySelectorAll('[data-ml-mobile]');
    if (!sources.length) return;

    var menu = document.getElementById('mobile_menu');
    if (!menu) return;

    Array.prototype.forEach.call(sources, function (src) {
      var handle = src.getAttribute('data-ml-handle');
      if (!handle) return;

      var li = menu.querySelector('li[data-mobile-dropdown-rel="' + handle + '"]');
      if (!li || li.classList.contains('ml-d-injected')) return;
      li.classList.add('ml-d-injected');

      // If a native submenu exists for this item (same-handle linklist),
      // hide it — the injected panel replaces it.
      Array.prototype.forEach.call(li.children, function (child) {
        if (child.tagName === 'UL') child.style.display = 'none';
      });

      var link = li.querySelector('a');

      var thumb = src.getAttribute('data-ml-thumb');
      if (link && thumb) {
        var img = document.createElement('img');
        img.className = 'ml-d-thumb';
        img.src = thumb;
        img.alt = '';
        link.insertBefore(img, link.firstChild);
      }

      var sub = document.createElement('div');
      sub.className = 'ml-d-sub';
      sub.hidden = true;
      sub.innerHTML = src.innerHTML;
      li.appendChild(sub);

      if (link) {
        // Hide the theme's own down-arrow if present; we add +/-
        var arrow = link.querySelector('.icon-down-arrow');
        if (arrow) arrow.style.display = 'none';

        var pm = document.createElement('span');
        pm.className = 'ml-d-pm';
        link.appendChild(pm);

        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = !sub.hidden;
          sub.hidden = isOpen;
          li.classList.toggle('ml-open', !isOpen);
        });
      }
    });
  }

  /* Desktop: anchor each open panel under its parent nav item instead of
     letting it float centered in the full-width tier-2 strip. Delegated,
     so it survives the meganav re-injection and the sticky-nav clone. */
  function measurePanelWidth(panel) {
    if (panel.dataset.mlWidth) return parseFloat(panel.dataset.mlWidth);
    var clone = panel.cloneNode(true);
    clone.style.cssText = 'position:absolute;left:-9999px;top:0;visibility:hidden;display:flex;margin:0;';
    document.body.appendChild(clone);
    var w = clone.offsetWidth;
    clone.remove();
    if (w) panel.dataset.mlWidth = w;
    return w;
  }

  function positionPanel(li) {
    var wrap = li.querySelector('[data-nav-desktop-tier-2]');
    var panel = li.querySelector('.ml-menu-panel');
    if (!wrap || !panel) return;

    var w = panel.offsetWidth || measurePanelWidth(panel);
    if (!w) return;

    var liRect = li.getBoundingClientRect();
    var wrapRect = wrap.getBoundingClientRect();
    var wrapLeft = wrapRect.width ? wrapRect.left : 0;
    var vw = document.documentElement.clientWidth;
    var left = liRect.left + liRect.width / 2 - w / 2;
    left = Math.max(12, Math.min(left, vw - w - 12));
    panel.style.margin = '0';
    panel.style.marginLeft = (left - wrapLeft) + 'px';
  }

  function onDesktopIntent(e) {
    if (!e.target.closest) return;
    var li = e.target.closest('[data-nav-desktop-parent]');
    if (li && li.querySelector('.ml-menu-panel')) positionPanel(li);
  }

  document.addEventListener('mouseover', onDesktopIntent);
  document.addEventListener('click', onDesktopIntent);
  document.addEventListener('focusin', onDesktopIntent);

  /* Desktop: 400ms hover-intent delay before opening a panel (research:
     300-500ms prevents accidental opens/flicker; the theme opens
     instantly). We intercept mouseover in the capture phase, hold it,
     and replay it if the cursor is still on the item 400ms later.
     Click/tap/keyboard still open instantly. */
  var INTENT_DELAY = 400;
  var intentTimer = null;
  var intentLi = null;

  document.addEventListener('mouseover', function (e) {
    if (e.mlIntentReplay) return;
    if (!e.target.closest) return;
    var li = e.target.closest('[data-nav-desktop-parent]');
    if (!li || !li.querySelector('.ml-menu-panel')) return;
    var details = li.querySelector('[data-nav-desktop-details]');
    if (details && details.hasAttribute('open')) return;
    /* Already engaged with the menu (a sibling panel is open or still
       closing)? Switch instantly — the intent delay only exists to
       prevent accidental first opens. */
    var list = li.closest('[data-nav-desktop-tier-1]');
    if (list) {
      var openSibling = list.querySelector('[data-nav-desktop-details][open]');
      if (openSibling && !li.contains(openSibling)) {
        /* Switching panels: skip the 0.2s fade-in too — the fade is for
           opens from nothing, not hops between items. ml-no-fade shortens
           the transition to ~0 (not none: the theme waits for the
           transitionend event, which transition:none would never fire). */
        var wrap = li.querySelector('[data-nav-desktop-tier-2]');
        if (wrap) {
          wrap.classList.add('ml-no-fade');
          clearTimeout(wrap.mlNoFadeTimer);
          wrap.mlNoFadeTimer = setTimeout(function () {
            wrap.classList.remove('ml-no-fade');
          }, 400);
        }
        return;
      }
    }
    e.stopPropagation();
    if (intentLi === li && intentTimer) return;
    clearTimeout(intentTimer);
    intentLi = li;
    intentTimer = setTimeout(function () {
      intentTimer = null;
      var replay = new MouseEvent('mouseover', { bubbles: true });
      replay.mlIntentReplay = true;
      li.dispatchEvent(replay);
    }, INTENT_DELAY);
  }, true);

  document.addEventListener('mouseout', function (e) {
    if (!e.target.closest) return;
    var li = e.target.closest('[data-nav-desktop-parent]');
    if (li && li === intentLi && !li.contains(e.relatedTarget)) {
      clearTimeout(intentTimer);
      intentTimer = null;
      intentLi = null;
    }
  }, true);

  /* Desktop: clicking the little caret arrow always toggles the panel —
     never navigates. Clicking the words keeps the theme behavior
     (open first, navigate when already open). */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var caret = e.target.closest('.nav-desktop__tier-1-link .icon-down-arrow');
    if (!caret) return;
    var li = caret.closest('[data-nav-desktop-parent]');
    if (!li || !li.querySelector('.ml-menu-panel')) return;
    e.preventDefault();
    e.stopPropagation();
    /* cancel any pending hover-intent so it can't double-fire */
    clearTimeout(intentTimer);
    intentTimer = null;
    intentLi = null;
    var details = li.querySelector('[data-nav-desktop-details]');
    if (details && details.hasAttribute('open')) return; /* already open: stay open */
    var replay = new MouseEvent('mouseover', { bubbles: true });
    replay.mlIntentReplay = true;
    li.dispatchEvent(replay);
  }, true);

  /* Desktop (mouse only): clicking the WORDS of a panel item always
     navigates immediately — the panel itself is reachable via hover or
     the caret. Without this, the theme spends the first click on
     opening the panel, which reads as "nothing happened". Keyboard
     (e.detail === 0) and touch devices keep the open-first behavior. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.detail === 0) return;
    if (e.target.closest('.icon-down-arrow')) return;
    var link = e.target.closest('.nav-desktop__tier-1-link');
    if (!link || !('href' in link.dataset) || !link.dataset.href) return;
    var li = link.closest('[data-nav-desktop-parent]');
    if (!li || !li.querySelector('.ml-menu-panel')) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    e.preventDefault();
    e.stopPropagation();
    window.location = link.dataset.href;
  }, true);

  /* Desktop: keep the active section highlighted in the bar. The theme
     does this natively, but the meganav injection rebuilds menu items
     from a template and loses the active class — restore it, and also
     mark a parent active when the CURRENT page appears anywhere in its
     panel (e.g. a sub-collection). */
  function markActive() {
    var path = location.pathname.replace(/\/$/, '');
    if (!path) return;
    document.querySelectorAll('[data-nav-desktop-tier-1] > li').forEach(function (li) {
      var link = li.querySelector('[data-nav-desktop-link]');
      if (!link || link.classList.contains('nav-desktop__tier-1-link--active')) return;
      var hrefs = [];
      var own = link.getAttribute('data-href') || link.getAttribute('href');
      if (own) hrefs.push(own);
      li.querySelectorAll('.ml-menu-panel a[href]').forEach(function (a) {
        hrefs.push(a.getAttribute('href'));
      });
      var match = hrefs.some(function (h) {
        try {
          return new URL(h, location.origin).pathname.replace(/\/$/, '') === path;
        } catch (e) {
          return false;
        }
      });
      if (match) link.classList.add('nav-desktop__tier-1-link--active');
    });
  }

  /* Mobile: red badge tiles for the non-category rows */
  function addBadges() {
    var menu = document.getElementById('mobile_menu');
    if (!menu) return;
    var BADGES = {
      'best-sellers': { text: '★', size: '22px' },
      'new': { text: 'NEW', size: '11px' },
      'deals': { text: '%', size: '20px' }
    };
    Object.keys(BADGES).forEach(function (rel) {
      var li = menu.querySelector('li[data-mobile-dropdown-rel="' + rel + '"]');
      if (!li || li.querySelector('.ml-d-thumb, .ml-d-badge')) return;
      var a = li.querySelector('a');
      if (!a) return;
      var b = document.createElement('span');
      b.className = 'ml-d-badge';
      b.textContent = BADGES[rel].text;
      b.style.fontSize = BADGES[rel].size;
      a.insertBefore(b, a.firstChild);
    });
  }

  /* Mobile: de-emphasized Reviews / Support section above the theme's
     own Login item at the drawer bottom (research: separate shopping
     links from support links) */
  function addUtilitySection() {
    var menu = document.getElementById('mobile_menu');
    if (!menu || menu.querySelector('.ml-d-sec')) return;
    var sec = document.createElement('li');
    sec.className = 'ml-d-sec';
    sec.innerHTML =
      '<a href="/pages/motoloot-reviews">Reviews</a>' +
      '<a href="/pages/contact-us">Support</a>';
    var loginLink = menu.querySelector('a[href*="/account"], a[href*="customer_authentication"]');
    var loginLi = loginLink ? loginLink.closest('li') : null;
    if (loginLi) {
      menu.insertBefore(sec, loginLi);
      loginLi.classList.add('ml-d-sec-item');
    } else {
      menu.appendChild(sec);
    }
  }

  /* Mobile: social-proof strip at the bottom of the drawer */
  function addProofStrip() {
    var menu = document.getElementById('mobile_menu');
    if (!menu || document.querySelector('.ml-d-proof')) return;
    var proof = document.createElement('a');
    proof.className = 'ml-d-proof';
    proof.href = '/pages/motoloot-reviews';
    proof.innerHTML = '<span class="ml-d-proof__stars" style="color:#ffb400">★★★★★</span>&nbsp; 4.94 average · 22,000+ five-star rider reviews';
    menu.parentNode.appendChild(proof);
  }

  /* Mobile: tapping outside the open drawer closes it.
     MUST close through the theme's MobileMenuDrawer.close() — it alone
     removes body.is-active (scroll lock) and resets the hamburger icon,
     and only after its close transition finishes. Removing the open
     attribute directly hides the drawer instantly, the transitionend
     the theme waits on never fires, and the page behind is left
     scroll-locked under a full-screen invisible header. */
  function bindOutsideClose() {
    document.addEventListener('click', function (e) {
      var details = document.querySelector('details[data-mobile-menu]');
      if (!details || !details.hasAttribute('open')) return;
      if (details.contains(e.target)) return;
      if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.close === 'function') {
        window.mobileMenuDrawer.close();
      } else {
        details.removeAttribute('open');
      }
    });
  }

  /* Warm the lazy-loaded menu images the moment the user shows intent
     (hover near the desktop nav / tap the hamburger), so panels and
     accordions open with images already cached. Keeps page-load free
     of the ~30 menu image requests. */
  function warmImages(root) {
    if (!root) return;
    Array.prototype.forEach.call(root.querySelectorAll('img'), function (img) {
      if (img.dataset.mlWarmed) return;
      img.dataset.mlWarmed = '1';
      var w = new Image();
      w.src = img.currentSrc || img.src;
    });
  }

  var deskWarmed = false;
  document.addEventListener('pointerover', function (e) {
    if (deskWarmed || !e.target.closest) return;
    if (!e.target.closest('[data-nav-desktop]')) return;
    deskWarmed = true;
    Array.prototype.forEach.call(document.querySelectorAll('[data-meganav-desktop], .ml-menu-panel'), warmImages);
  }, true);

  var mobWarmed = false;
  document.addEventListener('click', function (e) {
    if (mobWarmed || !e.target.closest) return;
    if (!e.target.closest('[data-mobile-menu-trigger]')) return;
    mobWarmed = true;
    warmImages(document.getElementById('mobile_menu'));
  }, true);

  function boot() {
    init();
    addBadges();
    addUtilitySection();
    addProofStrip();
    bindOutsideClose();
    markActive();
    /* the theme's injection can finish after we run — check again */
    setTimeout(markActive, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
